import React, { useState, useContext, useEffect, useMemo, useRef } from "react"
import styled from "styled-components"
import { navigate } from "gatsby"
import { SectionContext } from "../context/sectionContext"
import { PageContext } from "../context/pageContext"
import { JourneyContext } from "../context/journeyContext"
import { PaymentConfigContext } from "../context/PaymentConfigContext"
import { fetchAllJourneyData, paymentText, saveApplication, saveTransactionDetails ,checkPaymentStatus,paymentTextDecrypt, updateProductDetails, getTOFpaymentReceipt, getConfigurationsByType } from "../../services/apiservice"
import * as lookup from "../../../static/lookup.json"
import Select from "react-select"
import { applyComma, calculateAge } from '../../shared/functions'
import { errorToastr } from "../../services/error-handler"

let options1 = [
  {
    value: "bankAccountNumber",
    label: "Bank Account Number",
    minMaxLength: "12",
    type: "text"
  },
  {
    value: "hsbc",
    label: "HSBC Customer ID",
    minMaxLength: "9",
    type: "text"
  },
  {
    value: "debit",
    label: "Debit Card Number",
    minMaxLength: "16",
    type: "password"
  },
  {
    value: "credit",
    label: "Credit Card Number",
    minMaxLength: "16",
    type: "password"
  },
]


let options = options1.map((el) => ({
  value: el.value,
  label: el.label,
  minMaxLength: el.minMaxLength
}))

const InputContainer1 = styled.div`
  display: block;
  flex-direction: column;
  margin: 15px 0;
  position: relative;
  box-sizing: border-box;
  font-size: 15px;
  color: #505050;
  float: left;

  & > input {
  }
  & > label {
    margin-left: 8px;
    margin-bottom: 5px;
    color: #505050;
    font-size: 16px;
    background-color: ${props => props.channel === "28" || props.channel === "35" || props.channel === "39" ? "#ededed" : "#fff"};
    background-color: var(--lumiq-bg);
    padding: 2px 5px;
    /* z-index: 999; */
    position: relative;
    display: inline-block;
    cursor: default;
    max-width: 100%;
    min-height: 2rem;
  }
`

const DateContainer = styled.div`
  display: block;
  flex-direction: column;
  margin: 15px 0;
  position: relative;
  box-sizing: border-box;
  font-size: 15px;
  color: #505050;
  float: left;

  & > .form-control {
    box-shadow: 0 0 0 30px ${props => props.channel === "28" || props.channel === "35" || props.channel === "39" ? "#000000" : props.channel === "B" ? "#a20a3a" : props.channel === "C" ? "#0ab0ef" : "#eb7f25"} inset !important;
    box-shadow: 0 0 0 30px var(--lumiq-secondary) inset !important;
    color: white;
  }

  & > .date-input {
    display: flex;
    position: relative;
    border: 1px solid #929292;
    padding-right: 6px;
    input {
      width: 100%;
      border: none;
      outline: none;
      z-index: 5;
      background: transparent;

      &::-webkit-calendar-picker-indicator {
        color: rgba(0, 0, 0, 0);
        opacity: 0;
        cursor: pointer;
      }
    }

    .input-icon {
      position: absolute;
      right: 1rem;
      cursor: pointer;
      bottom: -5px;
      & > * {
        color: ${props => props.channel === "28" || props.channel === "35" || props.channel === "39" ? "#db0011" : props.channel === "B" ? "#a20a3a" : props.channel === "C" ? "#fec32b" : "#eb7f25"};
        color: var(--lumiq-tertiary);
      }
    }
  }

  & > label {
    margin-left: 8px;
    margin-bottom: 5px;
    color: #505050;
    font-size: 16px;
    background: ${props => props.channel === "28" || props.channel === "35" || props.channel === "39" ? "#ededed" : "#fff"};
    background: var(--lumiq-bg);
    color: white;
    padding: 2px 5px;
    z-index: 999;
    position: relative;
    display: inline-block;
    cursor: default;
    max-width: 100%;
  }
`

const SelectContainer = styled.div`
  display: block;
  flex-direction: column;
  margin: 18px 0;
  position: relative;
  box-sizing: border-box;
  font-size: 15px;
  color: #505050;
  float: left;
  min-width: 100%;
  max-width: 100%;

  & > .css-2b097c-container {
    margin-top: -17px;

    & div.css-1pahdxg-control{
      background: ${props => props.channel === "28" || props.channel === "35" || props.channel === "39" ? "#ededed" : "#fff"}  !important;
      background: var(--lumiq-bg) !important;
    }

    & > div {
      border-radius: 0;
      border: 1px solid #929292;
      padding: 1rem 0;
      padding-bottom: 0;
    }
    .css-1uccc91-singleValue{
      color:inherit;
      font-size: 1.3rem;
    }

    & div.css-yk16xz-control{
      background: ${props => props.channel === "28" || props.channel === "35" || props.channel === "39" ? "#ededed" : "#fff"};
      background: var(--lumiq-bg);

      .css-1hb7zxy-IndicatorsContainer > div{
        padding: 0 !important;        
        padding-right: 4px !important;        
      }
    }
    .css-1gtu0rj-indicatorContainer{
      padding: 0 !important;
      padding-right: 4px !important;        

    }
    & > div.css-26l3qy-menu {
      z-index: 500 !important;
      background: ${props => props.channel === "28" || props.channel === "35" || props.channel === "39" ? "#ededed" : "#fff"};
      background:var(--lumiq-bg)
    }

    & > div {
      box-shadow: none !important;
      border: 1px solid #929292;
    }
    & .css-1okebmr-indicatorSeparator {
      background: transparent;
    }
  }

  & > label {
    margin-left: 8px;
    margin-bottom: 5px;
    color: #505050;
    font-size: 16px;
    background: ${props => props.channel === "28" || props.channel === "35" || props.channel === "39" ? "#ededed" : "#fff"};
    background: var(--lumiq-bg);
    padding: 2px 5px;
    z-index: 1;
    position: relative;
    display: inline-block;
    cursor: default;
  }
`

const RadioContainer = styled.div`
width: 100%;
display: block;
flex-direction: column;
margin: 15px 0;
position: relative;
box-sizing: border-box;
font-size: 15px;
color: #505050;
float: left;

& > label {
  margin-left: 8px;
  margin-bottom: 5px;
  color: #505050;
  font-size: 16px;
  background-color: #fff;
  padding: 2px 5px;
  z-index: 999;
  position: relative;
  display: inline-block;
  cursor: default;
  max-width: 100%;
  & > .radio-label {
    text-align: center;
  }
}

.card {
  width: 100%;
  padding:1rem0;
  border-radius: 1rem;
  border-radius: 15px;
  background-color: #fff;
  position: relative;
  margin: 0px;
  margin-bottom: 0px;
  cursor: pointer;
  height: 9rem;
  max-height:max-content
  margin-top: 0px;
  box-shadow: 0px 0px 20px #ccc;
  transition: all 200ms;

  .amount {
    display:flex;
    align-items:center;
    justify-content:center;
    color: black;
    padding-left: 1.5rem;
    height: 3rem;
    font-size: 21px;
  }
  .desc {
    padding: 0.8rem;
    background: #ededed;
    color: black;
    text-align: center;
    padding-right: 34px;
  }
}

/*Check tick start  */
.checked {
  background: #ededed;
  color: #ededed;
  position: absolute;
  left: 1rem;
  top: 1rem;
  height: 2.5rem;
  width: 2.5rem;
  border-radius: 50%;
  padding: 8px;
  & > * {
    font-size: 1.2rem;
  }
}

input:checked ~ .card .checked {
  background: #fff;
  color: ${props =>
        props.channel === "A"
            ? "#3e505d"
            : props.channel === "B"
                ? "#a20a3a"
                : props.channel === "C"
                    ? "#0ab0ef"
                    : "#eb7f25"};
  color: var(--lumiq-card-bg);
}
/*Check tick end */

.icon-container {
  font-size: 3rem;
  padding: 1rem;
  span {
    border-radius: 50%;
    padding: 1rem;

    background: #3e505d;
    .hero-icon {
      padding-top: 8px;
      color: #fff;
    }
  }
}

input:checked ~ .card {
  background-color: ${props =>
        props.channel === "A"
            ? "#3e505d"
            : props.channel === "B"
                ? "#a20a3a"
                : props.channel === "C"
                    ? "#0ab0ef"
                    : "#eb7f25"};
  background-color: var(--lumiq-card-bg);
  color: #fff;
  .icon-container-1 {
    span {
      background: #fff;
      .hero-icon {
        color: #3e505d;
      }
    }
  }

  .amount {
    display:flex;
    align-items:center;
    justify-content:center;
    color: white;
    padding-left: 1.5rem;
    height: 3rem;
    font-size: 21px;
  }
  .desc {
    padding: 0.8rem;
    background: #ffffff;
    color:black
    text-align: center;
    padding-right: 34px;
  }
}

input:not(:checked) ~ .card {
  /* opacity: 0.5; */
  .amount {
    color: #818181;
  }

  .desc {
    color: #3e505d;
  }
}

@media screen and (max-width: 767px) {
.option-buit-design-new-structure-selected .row > div {
width: 100% !important;
margin-bottom: 15px;
}

.provider {
min-width: auto;
width: 100%;
}

.card {
width: 100%;
}

@media screen and (max-width: 575px) {
  .card {
    .amount {
      font-size: 16px !important;
    }
    .desc {
      font-size: 12px !important;
    }
    .checked {
      height: 1.8rem !important;
      width: 1.8rem !important;
      & > * {
        font-size: 1rem !important;
      }
    }
  }
}
}
`

const InputContainer = styled.div`
  display: block;
  flex-direction: column;
  margin: 15px 0;
  position: relative;
  box-sizing: border-box;
  font-size: 15px;
  color: #505050;
  float: left;

  & > .form-control {
    box-shadow: 0 0 0 30px ${props => props.channel === "28" || props.channel === "35" || props.channel === "39" ? "#000000" : props.channel === "B" ? "#a20a3a" : props.channel === "C" ? "#0ab0ef" : "#eb7f25"} inset !important;
    box-shadow: 0 0 0 30px var(--lumiq-secondary) inset !important;
    color: white;
  }

  & > input {
  }
  & > label {
    margin-left: 8px;
    margin-bottom: 5px;
    color: white;
    font-size: 16px;
    background: ${props => props.channel === "28" || props.channel === "35" || props.channel === "39" ? "#ededed" : "#fff"};
    background-color: var(--lumiq-bg);
    padding: 2px 5px;
    z-index: 999;
    position: relative;
    display: inline-block;
    cursor: default;
    max-width: 100%;
    min-height: 2rem;
  }
`

const payOptions = [
  { key: "cheque", value: "Cheque" },
  { key: "dd", value: "DD" },
  { key: "credit", value: "Credit Card" },
  { key: "debit", value: "Debit Card" },
  { key: "net", value: "Net Banking" },
  { key: "upi", value: "UPI" },
  { key: "wallets", value: "Wallets" },
]

export default function Payment(props) {
  const [sectionState, setSectionState] = useContext(SectionContext)
  const [PaymentConfigData] = useContext(PaymentConfigContext);
  const { glomoPay, swiftPay } = PaymentConfigData;
  const [paymentMethod, setPaymentMethod] = useState("");
  const hasUserSelectedMethod = useRef(false);

  useEffect(() => {
    if (glomoPay && !swiftPay) {
      setPaymentMethod("online");
    } else if (!glomoPay && swiftPay) {
      setPaymentMethod("swift");
    } else if (glomoPay && swiftPay) {
      setPaymentMethod("");
    }
  }, [glomoPay, swiftPay]);

  const handlePayOption = ({ target }) => {
    hasUserSelectedMethod.current = true
    if (target.checked) {
      setPaymentMethod(target.value)
    } else {
      setPaymentMethod("")
    }
  }

  const [pageState, setPageState] = useContext(PageContext)
  const [journeyState, setJourneyState] = useContext(JourneyContext)
  const [allJourneyData, setAllJourneyData] = useState({})
  const [proceedWithOption, setProceedWithOption] = useState()

  const [dropDown, setDropDown] = useState("bankAccountNumber");
  const [minMaxLength, setMinMaxLength] = useState("12");
  const [showError, setShowError] = useState(false)
  const [bankAccountNumVal, setBankAccountNumVal] = useState();
  const [type, setType] = useState("text");
  const [errorMsg, setErrorMsg] = useState("Please enter Bank Account Number");
  const [label, setLabel] = useState("Bank Account Number");

  const [paymentTermsCond2, setPaymentTermsCond2] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showModalAge, setShowModalAge] = useState(false);
  const [ageDiff, setAgeDiff] = useState(false);
  const [biApiData, setBiApiData] = useState(null)
  const [skipPayment, setSkipPayment] = useState(false)
  // GST cutoff mismatch
  const [showModalGST, setShowModalGST] = useState(false)
  const [gstConfig, setGstConfig] = useState(null)
  
  // Product mismatch
  const [showModalProduct, setShowModalProduct] = useState(false)
  const [productConfig, setProductConfig] = useState(null)

  const { isProceedEnabled } = useMemo(() => {
  const isProceedEnabled = paymentMethod !== "" && paymentTermsCond2;

  return {
    isProceedEnabled,
  };
}, [
  paymentTermsCond2,
  paymentMethod,
]);

 

 

  useEffect(() => {
    const action = async () => {
      if (paymentMethod === "swift") return
      if (biApiData && journeyState.applicationNo) {
        try {
          const res = await getTOFpaymentReceipt(journeyState.applicationNo)
          const receipts = res.data || [];
          const validReceipts = receipts.filter(receipt => lookup.validReceiptStatus[0].hasOwnProperty(receipt.receiptStatus));
          let sum = 0;
          validReceipts.forEach(receipt => {
            sum += parseInt(receipt.amount);
          });
          if (sum >= (Math.round(biApiData?.[0]?.["MODAL_PREM_TAX"]))) {
            setSkipPayment(true);
          }
          setJourneyState(prev => ({
            ...prev,
            receipts: validReceipts
          }));

        } catch (error) {
          console.error(error)
        }
      }
    }
    action()
  }, [biApiData, journeyState.applicationNo, paymentMethod])

 useEffect(() => {
    const checkBIValidity = async () => {
      if (paymentMethod === "swift") return
      // 1. Age mismatch check
      if (allJourneyData?.ageAtBI) {
        const currentAge = calculateAge(allJourneyData?.lifeAssuredDetails?.dob)
        if (Number(currentAge) !== Number(allJourneyData?.ageAtBI)) {
          setShowModalAge(true)
          setAgeDiff(true)
          return
        }
      }

      // 2. GST cutoff check
      if (allJourneyData?.productDetails?.biGeneratedAt) {
        try {
          const gstConfig = await getConfigurationsByType({
            type: "gst-config",
          })
          const cutOffTime = Number(gstConfig.data?.[0]?.config?.cutOffTime)
          setGstConfig(gstConfig.data?.[0]?.config)
          if (
            cutOffTime &&
            Number(allJourneyData.productDetails.biGeneratedAt) < cutOffTime
          ) {
            setShowModalGST(true)
            return
          }else{
            console.info(cutOffTime,allJourneyData.productDetails.biGeneratedAt, "s")
          }
        } catch (err) {
          console.info("error in fetching gst config", err)
        }
      }

      // 3. ProductId mismatch check
      if (allJourneyData?.productDetails?.productId) {
        try {
          const currentProductId = journeyState?.productId

          if (
            currentProductId &&
            currentProductId !== allJourneyData.productDetails.productId
          ) {
            // fetch product-config
            const productIdConfig = await getConfigurationsByType({
              type: "product-id-config",
            })

            setProductConfig(productIdConfig.data?.[0]?.config)
            setShowModalProduct(true)
            return
          }
        } catch (err) {
          console.info("error in fetching product config", err)
        }
      }
    }

    checkBIValidity()
  }, [
    allJourneyData?.ageAtBI,
    allJourneyData?.productDetails?.biGeneratedAt,
    allJourneyData?.productDetails?.productId,
    journeyState.productId,
    paymentMethod
  ])


  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(() => {
    const action = async () => {
      if (journeyState.journeyId) {
        let payload = {
          journeyId: journeyState.journeyId,
        }

        const journeyResult = await fetchAllJourneyData(payload)
        setProceedWithOption(journeyResult?.lifeAssuredDetails?.proceedWith)
        setAllJourneyData(journeyResult);
        setBiApiData(journeyResult.productDetails.BIJson ? JSON.parse(journeyResult.productDetails.BIJson) : null)
        let lastTransaction = null;
        if (journeyResult?.giftCityPaymentMethod !== "swift") {
          lastTransaction = journeyResult?.transactionDetails?.transactions?.[journeyResult?.transactionDetails?.transactions?.length - 1];
          if (!lastTransaction || (lastTransaction?.status !== "Success")) {
            const exisitingPlanCode = journeyResult?.productDetails?.planOption
            if (!lookup.paymentPagePlanOption[0].hasOwnProperty(exisitingPlanCode)) {
              setShowModal(true)
              return;
            }
          }
        }

      
          if (!hasUserSelectedMethod.current && journeyResult?.giftCityPaymentMethod === "swift") {
            const nextIdx = props.sections.findIndex(s => s.sectionId === "FDsuccessfullPaymentDetails");
            if (nextIdx !== -1) props.setCurrentSectionIndex(nextIdx);
            return;
          }

        if (journeyResult?.giftCityPaymentMethod !== "swift" && journeyResult?.transactionDetails?.paymentStatus && journeyResult.transactionDetails.paymentStatus !== 'Aborted') {
          const lastTxn = journeyResult?.transactionDetails?.transactions?.[journeyResult?.transactionDetails?.transactions?.length - 1]
          if (lastTxn) {
            setJourneyState(prev => ({
              ...prev,
              paymentDecryptData: { ...lastTxn }
            }))
          }
          const nextIdx = props.sections.findIndex(s => s.sectionId === "gift-city-payment-status");
          if (nextIdx !== -1) props.setCurrentSectionIndex(nextIdx);
        }

      }
    }
    action()
  }, [journeyState.journeyId])


  const checkandPayNow = async () => {
    setJourneyState(prev => ({ ...prev, giftCityPaymentMethod: paymentMethod }));
    if (paymentMethod === "swift") return
    if (journeyState?.journeyId) {
      //fetch latest transaction details
      try {
        const journeyResult = await fetchAllJourneyData({ journeyId: journeyState.journeyId })
        if (journeyResult?.transactionDetails && journeyResult?.giftCityPaymentMethod !== "swift") {
          const lastTransaction = journeyResult?.transactionDetails?.transactions?.[journeyResult?.transactionDetails?.transactions.length - 1]
          // last transaction success then navigate to resume journey
          if (lastTransaction && (lastTransaction?.status === "Success")) {
            navigate(`/unauthorized-transaction`, { state: { applicationNumber: journeyState.applicationNo } })
          }
          else {
            try {
              // checking payment status using srcTraceId
              const res_str = await checkPaymentStatus(journeyResult.transactionDetails.srcTraceId)
              //for payment status Decryption
              if (lastTransaction && lastTransaction?.status === "Aborted" && !res_str) {
                handlePayNow()
                return
              }
              try {
                const res = await paymentTextDecrypt({ "encryptedtext": res_str })
                console.info(res, "paymentTextDecrypt")
                const newPaymentStatus = res.data.status
                lastTransaction.status = newPaymentStatus;
                let payloadForSaveTransaction = {
                  journeyId: journeyState.journeyId,
                  paymentType: "",//TODO if needed
                  ...lastTransaction
                }
                try {
                  await saveTransactionDetails(payloadForSaveTransaction)
                  // on status Pending there redirection to pending-transaction page
                  if (newPaymentStatus === "Pending") {
                    navigate(`/pending-transaction?applicationNumber=${res.data.applicationNumber}`, { state: { paymentStatus: "Pending", applicationNumber: res.data.applicationNumber } })
                  }
                  // status Success there redirection to resume-journey
                  else if (newPaymentStatus === "Success") {
                    // errorToastr("Unauthorized Payment")
                    navigate(`/unauthorized-transaction`, { state: { applicationNumber: journeyState.applicationNo } })
                  }
                  else {
                    handlePayNow()
                  }

                } catch (error) {
                  console.info("errror occured in saveTransactionDetails", error)
                }

              } catch (error) {
                console.info("errror occured in paymentTextDecrypt", error)
              }

            } catch (error) {
              console.info("errror occured in checkPaymentStatus", error)
            }
          }
        }
        // no transaction details found then user proceed payment normally.
        else {
          await handlePayNow()
        }
      } catch (error) {
        errorToastr("Something went wrong")
        console.info("errror occured in fetching data", error)
      }
    }
  }

  const handlePayNow = async () => {

    try {
      const sendPayload = {
        applicationData: journeyState.journeyData,
        journeyData: {
          _id: journeyState.journeyId,
          lastPage: props.currentPageIndex,
          lastSection: 2,//send to failed page to check when resumed in case payment was success
          applicationNo: journeyState.applicationNo,
          illustrationNumber: journeyState.illustrationNumber,
          proposalEntryId: journeyState.proposalEntryId,
          premium: journeyState.premium,
          lastPageCode: props.pageId,
          paymentStep: journeyState.paymentStep,
          lastSectionCode: "unsuccessful-transaction",
          planOption: journeyState.planOption,
          isBasbaAttempted: 'N',
          giftCityPaymentMethod: paymentMethod,
        },
      }
      await saveApplication(sendPayload) //save application
      const paymentPayload = {
        journeyId: journeyState.journeyId,
        // module: SIOrCheque
      }

      try {
        const res = await paymentText(paymentPayload)

        try {
          const abortTransactionPayload = {
            journeyId: journeyState.journeyId,
            applicationNumber: journeyState.applicationNo,
            status: 'Aborted',
            srcTraceId: res.data.payload.srcTraceId,
            amount: res.data.payload.amount,
            paymentTxnId: 0,
            source: 'ISNP',
            paymentTxnDate: res.data.payload.applicationLaunchDate,
            // paymentType: SIOrCheque
          }
          await saveTransactionDetails(abortTransactionPayload) //save aborted default transactions
          const redirectUrlPayload = {
            applicationNumber: journeyState.applicationNo,
            journeyId: journeyState.journeyId,
            source: journeyState.channel,
            // module: SIOrCheque,
          }
          const data = JSON.stringify(redirectUrlPayload)
          var encodedStringBtoA = btoa(data)
          let productKey = lookup?.urlLookup?.[journeyState.journeyIdFromStrapi]
          if (`${process.env.DEVELOPMENT}` === "Y") {//for si call enach url whereas for cheque call normal url
            const url = `${process.env.PAYMENT_URL}?rd=${res.data.text}&redirectUrl=${process.env.GATSBY_URL}/payment-redirection/`;
            window.open(url, "_self");
          }
          else if (`${process.env.DEVELOPMENT}` === "N") {
            const url = `${process.env.PAYMENT_URL}?rd=${res.data.text}&redirectUrl=${process.env.GATSBY_URL}/${productKey}/payment-redirection/`;
            window.open(url, "_self");
          }
        } catch (error) {
          console.info("errror occured in saveTransactionDetails", error)
        }

      } catch (error) {
        console.info("errror occured in paymentText", error)
      }

    } catch (error) {
      console.info("errror occured in saving application", error)
    }

  }

  const handleReCalculate = () => {
      props.setCurrentPageIndex(0)
      props.setCurrentSectionIndex(0)

      let tempPage
      if (journeyState.journeyIdFromStrapi === "FlexiEdgeJourney") {
        tempPage = journeyState.journeyData?.find(page => page.pageId === "PageFlexiEdgeCalculatePremium")
      } else if (journeyState.journeyIdFromStrapi === "titaniumPlusJourney") {
        tempPage = journeyState.journeyData?.find(page => page.pageId === "PageTitaniumPlusCalculateFundValue")
      } else if (journeyState.journeyIdFromStrapi === "FutureDollarGiftCityJourney") {
        tempPage = journeyState.journeyData?.find(page => page.pageId === "PageFutureDollarGiftCityCalculateFundValue")
      } else if (journeyState.journeyIdFromStrapi === "GuarateedOnePayJourney") {
        tempPage = journeyState.journeyData?.find(page => page.pageId === "PageGuaranteedOnePayCalculatePremium")
      } else if (journeyState.journeyIdFromStrapi === "guaranteedIncomeAdvantage") {
        tempPage = journeyState.journeyData?.find(page => page.pageId === "PageGuaranteedIncomeAdvantageCalculatePremium")
      } else if (journeyState.journeyIdFromStrapi === "guaranteedSavingsOption") {
        tempPage = journeyState.journeyData?.find(page => page.pageId === "PageGuaranteedSavingsCalculatePremium")
      } else if (journeyState.journeyIdFromStrapi === "insureSmart") {
        tempPage = journeyState.journeyData?.find(page => page.pageId === "PageInsureSmartCalculateFundValue")
      } else if (journeyState.journeyIdFromStrapi === "jeevanNivesh") {
        tempPage = journeyState.journeyData?.find(page => page.pageId === "PageJeevenNiveshCalculatePremium")
      } else if (journeyState.journeyIdFromStrapi === "moneyBackAdvantage") {
        tempPage = journeyState.journeyData?.find(page => page.pageId === "PageMoneyBackCalculatePremium")
      } else if (journeyState.journeyIdFromStrapi === "invest4GJourney") {
        tempPage = journeyState.journeyData?.find(page => page.pageId === "PageInvest4GCalculateFundValue")
      } else if (journeyState.journeyIdFromStrapi === "smartJuniorPlan") {
        tempPage = journeyState.journeyData?.find(page => page.pageId === "PageSmartJuniorCalculatePremium")
      } else if (journeyState.journeyIdFromStrapi === "secureBhavishyaJourney") {
        tempPage = journeyState.journeyData?.find(page => page.pageId === "PageSecureBhavishyaCalculatePremium")
      } else if (journeyState.journeyIdFromStrapi === "guaranteedFortuneJourney") {
        tempPage = journeyState.journeyData?.find(page => page.pageId === "PageGuaranteedFortuneCalculatePremium")
      } else if (journeyState.journeyIdFromStrapi === "guaranteedFutureJourney") {
        tempPage = journeyState.journeyData?.find(page => page.pageId === "PageGuaranteedFutureCalculatePremium")
      } else if (journeyState.journeyIdFromStrapi === "guaranteedIncome4LifeJourney") {
        tempPage = journeyState.journeyData?.find(page => page.pageId === "PageGuaranteedIncome4LifeCalculatePremium")
      } else if (journeyState.journeyIdFromStrapi === "GAINjourney") {
        tempPage = journeyState.journeyData?.find(page => page.pageId === "GAINcalculatePremiumPage")
      } else {
        tempPage = journeyState.journeyData?.find(page => page.pageId === "PageISelect360CalculatePremium")
      }
      let sectionsTokeep = tempPage.pageData.filter((section => {
        return !["iSelect360CPOptionalInBuilt", "iSelect360CPSpouseCoverDetails"].includes(section.sectionId)
      }))

      setPageState(prev => {
        return {
          ...prev,
          pageId: tempPage.pageId,
          pageData: sectionsTokeep,
        }
      })
      let tempState
      if (journeyState.journeyIdFromStrapi === "FlexiEdgeJourney") {
        tempState = tempPage.pageData.find(section => section.sectionId === "SectionFlexiEdgeCalculatePremiumPersonalDetails")
      } else if (journeyState.journeyIdFromStrapi === "titaniumPlusJourney") {
        tempState = tempPage.pageData.find(section => section.sectionId === "CFSectionTitaniumPersonelDetails")
      } else if (journeyState.journeyIdFromStrapi === "FutureDollarGiftCityJourney") {
        tempState = tempPage.pageData.find(section => section.sectionId === "FutureDollarGiftCityPersonelDetailsSection")
      } else if (journeyState.journeyIdFromStrapi === "GuarateedOnePayJourney") {
        tempState = tempPage.pageData.find(section => section.sectionId === "SectionGOPAPersonelDetails")
      } else if (journeyState.journeyIdFromStrapi === "guaranteedIncomeAdvantage") {
        tempState = tempPage.pageData.find(section => section.sectionId === "SectionGuaranteedIncomeAdvantagePersonelDetails")
      } else if (journeyState.journeyIdFromStrapi === "guaranteedSavingsOption") {
        tempState = tempPage.pageData.find(section => section.sectionId === "SectionGuaranteedSavingsPersonelDetails")
      } else if (journeyState.journeyIdFromStrapi === "insureSmart") {
        tempState = tempPage.pageData.find(section => section.sectionId === "SectionInsureSmartPersonelDetails")
      } else if (journeyState.journeyIdFromStrapi === "jeevanNivesh") {
        tempState = tempPage.pageData.find(section => section.sectionId === "SectionJeevanNiveshCalculatePremiumPersonalDetails")
      } else if (journeyState.journeyIdFromStrapi === "moneyBackAdvantage") {
        tempState = tempPage.pageData.find(section => section.sectionId === "SectionMoneyBackPersonalDetails")
      } else if (journeyState.journeyIdFromStrapi === "invest4GJourney") {
        tempState = tempPage.pageData.find(section => section.sectionId === "SectionInvest4GPersonelDetails")
      } else if (journeyState.journeyIdFromStrapi === "smartJuniorPlan") {
        tempState = tempPage.pageData.find(section => section.sectionId === "SectionSmartJuniorPersonelDetails")
      } else if (journeyState.journeyIdFromStrapi === "secureBhavishyaJourney") {
        tempState = tempPage.pageData.find(section => section.sectionId === "SectionSecureBhavishyaPersonelDetails")
      } else if (journeyState.journeyIdFromStrapi === "guaranteedFortuneJourney") {
        tempState = tempPage.pageData.find(section => section.sectionId === "SectionGuaranteedFortunePersonelDetails")
      } else if (journeyState.journeyIdFromStrapi === "guaranteedFutureJourney") {
        tempState = tempPage.pageData.find(section => section.sectionId === "SectionGuaranteedFuturePersonelDetails")
      } else if (journeyState.journeyIdFromStrapi === "guaranteedIncome4LifeJourney") {
        tempState = tempPage.pageData.find(section => section.sectionId === "SectionGuaranteedIncome4LifePersonelDetails")
      } else if (journeyState.journeyIdFromStrapi === "GAINjourney") {
        tempState = tempPage.pageData.find(section => section.sectionId === "GAINpersonalDetailsSection")
      } else {
        tempState = tempPage.pageData.find(section => section.sectionId === "CPPersonalDetailsSection")
      }
      setSectionState(prev => {
        return {
          ...prev,
          sectionId: tempState.sectionId,
          sectionData: tempState.sectionData,
        }
      })
  }
  // code of tab enter
  const handleEnterRecalculate = (event) => {
    if (event?.key == 'Enter') {
      handleReCalculate();
    }
  }


  const handleDropDown = e => {
    setErrorMsg("");
    console.log(e);
    if (e?.value) {
      let el = options1.find(el => el.value == e.value)
      if (el) {
        setDropDown(el.value);
        setMinMaxLength(el.minMaxLength);
        setType(el.type);
        setLabel(el.label);
        setBankAccountNumVal("");
      }
    } else {
      setDropDown("");
    }
  }

  const bankAccountInput = e => {
    if (!isNaN(e.target.value)) {
      if (e.target.value.length == minMaxLength) {
        setShowError(false);
        setErrorMsg("");
      }
      if (e.target.value.length === 0) {
        setShowError(true);
        setErrorMsg(`Please enter ${label}`)
      } else {
        setShowError(false);
        setErrorMsg("");
      }
      setBankAccountNumVal(e.target.value);
    } else {
      return;
    }
  }
  function getKeyByValue(object, value) {
    return object.find(key => key.value == value)
  }

  function capitalize(str) {
    const lower = str.toLowerCase();
    return str.charAt(0).toUpperCase() + lower.slice(1);
  }

  function capitalizeWords(str) {
    if (!str) return '';
    return str
      .split(' ') 
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) 
      .join(' '); 
  }


  const premiumFrequencyLookup = lookup["premiumFrequency"][0]
  const planOptionLookup = lookup["planOption"][0];
  const paymentPlanLookup= lookup["paymentPagePlanOption"][0];
  const productKey = lookup?.urlLookup?.[journeyState.journeyIdFromStrapi]

  const handleOnChange = (data) => {
    if (data === "paymentTermsCond2") {
      setPaymentTermsCond2(!paymentTermsCond2);
    }
  }

  const handlePaymentProceedGiftCity = async () => {
    if (!paymentTermsCond2) {
      return
    }
    setJourneyState(prev => ({ ...prev, giftCityPaymentMethod: paymentMethod }));
    const nextIdx = props.sections.findIndex(s => s.sectionId === "FDsuccessfullPaymentDetails");
    
    try {
      const sendPayload = {
        applicationData: journeyState.journeyData,
        journeyData: {
          _id: journeyState.journeyId,
          lastPage: props.currentPageIndex,
          lastSection: nextIdx !== -1 ? nextIdx : 0,
          applicationNo: journeyState.applicationNo,
          illustrationNumber: journeyState.illustrationNumber,
          proposalEntryId: journeyState.proposalEntryId,
          premium: journeyState.premium,
          lastPageCode: props.pageId,
          paymentStep: journeyState.paymentStep,
          lastSectionCode: "FDsuccessfullPaymentDetails",
          planOption: journeyState.planOption,
          giftCityPaymentMethod: paymentMethod,
        },
      }
      await saveApplication(sendPayload)
    } catch (error) {
      console.info("error saving swift payment method", error)
    }

    if (nextIdx !== -1) {
      props.setCurrentSectionIndex(nextIdx);
    }
  }



  return (
    <>
      {/* checkbox css */}
      <style>
        {`/* The container */
      .checkbox-label {
        position: relative;
        padding-left: 35px;
        margin-bottom: 12px;
        cursor: pointer;
        font-size: 2rem;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
      }

      /* Hide the browser's default checkbox */
      .checkbox-label input {
        position: absolute;
        opacity: 0;
        cursor: pointer;
        height: 0;
        width: 0;
      }

      /* Create a custom checkbox */
      .checkmark {
        position: absolute;
        top: 0;
        left: 0;
        height: 25px;
        width: 25px;
        background-color: #ccc;
        border-radius:0;
      }

      /* On mouse-over, add a grey background color */
      .checkbox-label:hover input ~ .checkmark {
        background-color: #ccc;
      }

      /* When the checkbox is checked, add a theme background */
      .checkbox-label input:checked ~ .checkmark {
        background-color:  ${journeyState.channel === "28" || journeyState.channel === "35" || journeyState.channel === "39" ? "#db0011" : journeyState.channel === "B" ? "#a20a3a" : journeyState.channel === "C" ? "#fec32b" : "#eb7f25"};
        background-color:  var(--lumiq-tertiary);
      };
      }

      /* Create the checkmark/indicator (hidden when not checked) */
      .checkmark:after {
        content: "";
        position: absolute;
        display: none;
      }

      /* Show the checkmark when checked */
      .checkbox-label input:checked ~ .checkmark:after {
        display: block;
      }

      /* Style the checkmark/indicator */
      .checkbox-label .checkmark:after {
        left: 9px;
        top: 5px;
        width: 5px;
        height: 10px;
        border: solid white;
        border-width: 0 3px 3px 0;
        -webkit-transform: rotate(45deg);
        -ms-transform: rotate(45deg);
        transform: rotate(45deg);
      }`}
      </style>

      <style>
        {`
  
          .details-card-wrapper{
            width:80%;
            margin:0 auto

          }

          @media screen and (max-width:768px){
            .details-card-wrapper{
              width:98%;
            }
          }

          @media screen and (min-width:991px){
            .bankCSSFix{
              display:flex !important;
              flex-direction:row !important;
              margin-left: 120px !important;
              gap:3rem !important;
            }
          }
          @media screen and (max-width:990px){
            .bankCSSFix{
              display:flex !important;
              flex-direction: column !important;
            }
          }
          .details-card{      
              border-radius:10px;
              overflow:hidden;
              margin-bottom:1rem;
              border:1px solid ${journeyState.channel === "28" || journeyState.channel === "35" || journeyState.channel === "39" ? "#000000" : journeyState.channel === "B" ? "#a20a3a" : journeyState.channel === "C" ? "#0ab0ef" : "#eb7f25"};    
              border:1px solid var(--lumiq-secondary);
          }
          
          .details-card::last-child{
              margin-bottom:0;       
          }
          
          .header{
              background: ${journeyState.channel === "28" || journeyState.channel === "35" || journeyState.channel === "39" ? "#000000" : journeyState.channel === "B" ? "#a20a3a" : journeyState.channel === "C" ? "#0ab0ef" : "#eb7f25"};
              background: var(--lumiq-secondary);
              color: #fff;
              padding:1rem;
              text-align:center;
          }
  
          .data{
              display:flex;
              justify-content:space-between;
              padding:1rem;
              color:black;
              margin:0 4rem;
          }

          .data:not(:last-child){
            border-bottom:1px solid black;
            }
  
          .disclosure > *{
              margin-bottom:1rem;
  
          }     
          
          .note{
              padding:3rem;
              background: ${journeyState.channel === "28" || journeyState.channel === "35" || journeyState.channel === "39" ? "#000000" : journeyState.channel === "B" ? "#a20a3a" : journeyState.channel === "C" ? "#0ab0ef" : "#eb7f25"};
              background: var(--lumiq-secondary);
              color:white;
              border-radius:10px;
          }
          .note > *{
            font-style:italic;
          }

          .btn-actions{
              display:flex;
              justify-content:center;
              gap:2rem;
          }
          
          .payment-option{
            background: ${journeyState.channel === "28" || journeyState.channel === "35" || journeyState.channel === "39" ? "#000000" : journeyState.channel === "B" ? "#a20a3a" : journeyState.channel === "C" ? "#0ab0ef" : "#eb7f25"};
            background: var(--lumiq-secondary);
            color:white;
            padding:2rem

          }
          
          .payment-form{
              display:flex;
              flex-direction:column;
              align-items:center;
              justify-content:center;
          }
          .left{
              padding-right:4rem;
              border-right:1px solid white;
              width:30rem;
          }

          .left > *:not(:last-child){
              margin-bottom:1rem;
          }

          .right{
              width:100%;
              padding-left:4rem;
          }
          .payment-strip{
              min-height:5rem;
              display:flex;
              align-items:center;
              flex-wrap:wrap;
              padding:2rem 5rem;

              gap: 1.5rem 2rem;
              background:white;
              justify-content:space-around
          }

          .payment-strip > img{
              height:2rem;
              cursor:pointer
          }

          .payment-btn{
              color:white;
              border:1px solid white;
              padding:1.5rem;
              cursor:pointer;
              text-align:center;
              background:transparent;
            }
            .payment-btn.active{
              background: ${journeyState.channel === "28" || journeyState.channel === "35" || journeyState.channel === "39" ? "#db0011" : journeyState.channel === "B" ? "#a20a3a" : journeyState.channel === "C" ? "#fec32b" : "#eb7f25"};
              background: var(--lumiq-tertiary);
            }
            .payment-btn > a {
                color:white;
                text-decoration:none
            }
            
          
            .re-calculate{
                border:1px solid white;
                margin-left:1rem;

            }

          .re-calculate >  *{
              color:white !important;
          }

        .medium-icon{
          min-height:3.5rem;
        }
        .text-left{text-align:left}
        .text-right{text-align:right}
        
        .custom-form-control{
          height : 52px !important;
        }


          `}
      </style>
      <div className="landing-page1-design">
        <div className="container">
          <div className="row">
            <div className="col-md-12 ">
              <div className="iselect-box-design">
                <div className="heading-design">
                  <div className="iselect-padding left-side-head ckyc-w">
                    <h1 className="iselect-heading">Make Payment</h1>
                  </div>
                  <div class="app-quatation mt hidden-desktop-screen">
                    <div class="application-design-number">Application Number: {journeyState.applicationNo}</div>
                  </div>
                </div>

                <div className="iselect-padding ">
                  <div className="col-md-12 col-12 ">
                    <div className="details-card-wrapper">
                      <div className="details-card ">
                        <div
                          className="header"
                          style={{ background: `${journeyState.channel === "28" || journeyState.channel === "35" || journeyState.channel === "39" ? "#3e505d" : journeyState.channel === "B" ? "#a20a3a" : journeyState.channel === "C" ? "#0ab0ef" : "#eb7f25"}` }}
                        // style={{ background: "var(--lumiq-card-bg)" }}
                        >
                          <span>Payment Details</span>
                        </div>
                        <div className="listing-structure-design-payment">
                          <ul className="list-inline">
                            <li className="text-left">Name of the Product</li>
                            <li className="text-right">
                              {
                                paymentPlanLookup[
                                allJourneyData?.productDetails?.planOption
                                ]
                              }
                            </li>
                          </ul>
                          <ul className="list-inline">
                            <li className="text-left">
                              Premium Payment Term (years)
                            </li>
                            <li className="text-right">
                              {
                                capitalize(lookup["premiumPaymentTermPaymentLookup"][0][allJourneyData?.productDetails?.premiumPaymentTerm] || '1 year')
                              }
                            </li>
                          </ul>
                          <ul className="list-inline">
                            <li className="text-left">Base Sum Assured ($)</li>
                            <li className="text-right">
                              {allJourneyData?.productDetails?.sumAssured || ""}
                            </li>
                          </ul>
                          <ul className="list-inline">
                            <li className="text-left">Premium Frequency</li>
                            <li className="text-right">
                              {
                                premiumFrequencyLookup[
                                  allJourneyData?.productDetails?.premiumFrequency
                                ] ? capitalize(premiumFrequencyLookup[
                                  allJourneyData?.productDetails?.premiumFrequency
                                ]) : ""
                              }
                            </li>
                          </ul>
                          <ul className="list-inline">
                            <li className="text-left">
                              Name of the Policy Owner
                            </li>
                            <li className="text-right">
                              {
                                allJourneyData?.lifeAssuredDetails?.fullName ?
                                  capitalizeWords(allJourneyData?.lifeAssuredDetails?.fullName) : ""
                              }
                            </li>
                          </ul>
                          <ul className="list-inline">
                            <li className="text-left">
                              Total Installment Premium ($)
                            </li>
                            <li className="text-right">
                              {applyComma(allJourneyData?.productDetails?.installmentPremium ?? '')}
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {journeyState.channel === "A" || journeyState.channel === "28" || journeyState.channel === "35" || journeyState.channel === "39" || journeyState.channel === "12" || journeyState?.channel?.toUpperCase() === "CHLGIFTCITY" || journeyState?.channel?.toUpperCase() === "AGENCYGC" || journeyState?.channel?.toUpperCase() === "PBGIFTCITY" &&
                  <>
                     <div className="row" style={{
                      justifyContent : "center"
                     }}>
                      <div className="col-lg-4 col-md-12 col-12">
                        <SelectContainer channel={journeyState.channel} className={`input-container`} >
                          <label className="input-label" >
                            Bank Relationship ID
                            <span style={{ marginLeft: "10px" }} className="tooltip-col text-tool-tip-design existing-tool-tip">
                              <div className="tool">i</div>
                              <span className="tooltiptext4" style={{ width: "22rem", height: "fit-content", top: "auto", pointerEvents: "none", textAlign: "justify" }}>
                                This is required to validate that you are an existing customer of HSBC bank. Please provide either your account number or customer ID or debit/credit card number.
                              </span>
                            </span>
                          </label>
                          <Select
                            options={options}
                            name="Select"
                            key="Select"
                            id="InputSelect"
                            required={true}
                            value={getKeyByValue(options, dropDown)}
                            onChange={handleDropDown}

                          ></Select>
                        </SelectContainer>

                      </div>

                      <div className="col-lg-4 col-md-12 col-12" style={{
                    marginTop : "-7px",
                  }}>
                        <InputContainer1 channel={journeyState.channel} className="form-group">
                          <label className="input-label">
                            {dropDown == "bankAccountNumber"
                              ? "Enter your Bank Account Number"
                              : dropDown == "hsbc"
                                ? "Enter your HSBC Customer ID"
                                : dropDown == "debit"
                                  ? "Enter your Debit Card Number"
                                  : dropDown == "credit"
                                    ? "Enter your Credit Card Number"
                                    : ""}
                          </label>
                          <input
                            className="form-control custom-form-control"
                            type={type}
                            name="email"
                            value={bankAccountNumVal}
                            required={true}
                            autoComplete="new-password"
                            placeholder={
                              dropDown == "bankAccountNumber"
                                ? "Enter your Bank Account Number"
                                : dropDown == "hsbc"
                                  ? "Enter your HSBC Customer ID"
                                  : dropDown == "debit"
                                    ? "Enter your Debit Card Number"
                                    : dropDown == "credit"
                                      ? "Enter your Credit Card Number"
                                      : ""
                            }
                            maxlength={minMaxLength}
                            minLength={minMaxLength}
                            disabled={false}
                            id="selectAccount"
                            onChange={bankAccountInput}
                          ></input>
                          {showError ? (<span className="input-error">{errorMsg}</span>) : ""}
                        </InputContainer1>
                      </div>
                    </div>

                  </>
                }
                {paymentMethod === "swift" && !glomoPay ? (
                <div className="iselect-padding">
                  {/* Desktop tabs */}
                  <div
                    className="payment-option hidden-desktop-screen "
                    style={{ background: `${journeyState.channel === "28" || journeyState.channel === "35" || journeyState.channel === "39" ? "#3e505d" : journeyState.channel === "B" ? "#a20a3a" : journeyState.channel === "C" ? "#0ab0ef" : "#eb7f25"}` }}
                  // style={{ background: "var(--lumiq-card-bg)" }}
                  >
                   

                    {/* <h4>Choose Your Preferred Payment Option</h4> */}
                    <div className="payment-form">
                      {/* <div className="left">
                        {payOptions.map(payOption => {
                          return (
                            <div
                              className={`payment-btn ${
                                payOption.key == paymentMethod ? "active" : ""
                              }`}
                              onClick={() => handlePaymentOption(payOption.key)}
                            >
                              <a>{payOption.value}</a>
                            </div>
                          )
                        })}
                      </div> */}
                      
                      <div className="right">
                        {!["upi", "wallets"].includes(paymentMethod) ? (
                          <>
                            <div
                              style={{
                                textAlign: "center",
                                margin: "2rem 0",
                              }}
                            >
                              <div
                                className="row iAgree"
                                style={{
                                  textAlign: "center",
                                }}
                              >
                                <div className="form-group">
                                  <div className="inner-addon left-addon align-error" style={{ width: "67%", margin: "auto", alignItems: 'flex-start' }}>
                                    <div className="checkbox1">
                                      <input
                                        id="checkboxG7"
                                        className={`css-checkbox form-control`}
                                        type="checkbox"
                                        checked={paymentTermsCond2}
                                        onChange={(e) => handleOnChange("paymentTermsCond2")}
                                      />
                                      {['a','c', 'b', 'd'].includes(journeyState?.channel?.toLowerCase()) ? 
                                      (<label
                                        htmlFor="checkboxG7"
                                        className="css-label"
                                        style={{color:"white",filter:"brightness(1)" }}
                                      >
                                        I accept all terms &amp; conditions and hereby declare that premium shall be paid by Proposer.
                                      </label>) : 
                                     ( <label className="websiteCheckmarkcontainer">
                                        <span style={{
                                          marginLeft:"15px"
                                        }}>I accept all terms &amp; conditions and hereby declare that premium shall be
                                        paid by Proposer.</span>
                                        <input type="checkbox" checked={paymentTermsCond2}  onChange={(e)=>handleOnChange("paymentTermsCond2")} />
                                        <span className="checkmarkWebsite" />
                              </label>)}
                                    </div>
                                    {!paymentTermsCond2 && (<span className="input-error payment-error1" style={{ fontSize: '13px', marginLeft: "5.2rem" }}>
                                      This field is required
                                    </span>)}
                                  </div>
                                </div>
                              </div>
                              <p>
                                If your age changes during the period your
                                insurance proposal is under consideration with
                                the company, then the premium as per your
                                attained age will apply and you will be required
                                to pay the additional amount for issuing the
                                policy.
                              </p>
                            </div>
                          </>
                        ) : null}
                        <div
                          className="col-md-12"
                          style={{ paddingTop: "3rem" }}
                        >
                          <div className="but-center text-center">
                            <input
                              type="submit"
                              className="provider previous-btn cen pay-now"
                              tabIndex="0"
                              onMouseOver={(e) => {
                                if (!['a','c', 'b', 'd'].includes(journeyState?.channel?.toLowerCase())){
                                  e.target.style.background = '#404040'
                                  e.target.style.border = '1px solid #404040'
                                }
                              }}
                              onFocus={(e) => {if (!['a','c', 'b', 'd'].includes(journeyState?.channel?.toLowerCase())){
                                e.target.style.background = journeyState.channel?.toLowerCase() == 'b'
                                ? `${journeyState.channel === "28" || journeyState.channel === "35" || journeyState.channel === "39" ? "#404040" : journeyState.channel === "B" ? "#a20a3a" : journeyState.channel === "C" ? "#fec32b" : "#eb7f25"}` 
                                : journeyState.channel?.toLowerCase() == 'd'
                                  ? '#cc6c1d'
                                  : `${journeyState.channel === "28" || journeyState.channel === "35" || journeyState.channel === "39" ? "#db0011" : journeyState.channel === "B" ? "#a20a3a" : journeyState.channel === "C" ? "#fec32b" : "#eb7f25"}` 
                                  e.target.style.border = '1px solid white'
                              }}}
                              onMouseOut={(e) => {
                                if (!['a','c', 'b', 'd'].includes(journeyState?.channel?.toLowerCase())){
                                  e.target.style.background = journeyState.channel?.toLowerCase() == 'b'
                                  ? `${journeyState.channel === "A" ? "#404040" : journeyState.channel === "B" ? "#a20a3a" : journeyState.channel === "C" ? "#fec32b" : "#eb7f25"}` 
                                  : journeyState.channel?.toLowerCase() == 'd'
                                    ? '#cc6c1d'
                                    : `${journeyState.channel === "28" || journeyState.channel === "35" || journeyState.channel === "39" ? "#db0011" : journeyState.channel === "B" ? "#a20a3a" : journeyState.channel === "C" ? "#fec32b" : "#eb7f25"}` 
                                    e.target.style.border = '1px solid white'
                                }
                              }}
                              onBlur={(e) => {
                                if (!['a','c', 'b', 'd'].includes(journeyState?.channel?.toLowerCase())){
                                  e.target.style.background = journeyState.channel?.toLowerCase() == 'b'
                                  ? `${journeyState.channel === "28" || journeyState.channel === "35" || journeyState.channel === "39" ? "#404040" : journeyState.channel === "B" ? "#a20a3a" : journeyState.channel === "C" ? "#fec32b" : "#eb7f25"}` 
                                  : journeyState.channel?.toLowerCase() == 'd'
                                    ? '#cc6c1d'
                                    : `${journeyState.channel === "28" || journeyState.channel === "35" || journeyState.channel === "39" ? "#db0011" : journeyState.channel === "B" ? "#a20a3a" : journeyState.channel === "C" ? "#fec32b" : "#eb7f25"}` 
                                    e.target.style.border = '1px solid white'
                                }
                              }}
                              style={{
                                color: "white",
                                padding: "14px 40px",
                                border: ['a','c', 'b', 'd'].includes(journeyState?.channel?.toLowerCase()) ? "none" : "1px solid white",
                                marginLeft: "8px",
                                background: journeyState.channel?.toLowerCase() == 'b'
                                  ? `${journeyState.channel === "28" || journeyState.channel === "35" || journeyState.channel === "39" ? "#404040" : journeyState.channel === "B" ? "#a20a3a" : journeyState.channel === "C" ? "#fec32b" : "#eb7f25"}` //var(--lumiq-secondary2)
                                  : journeyState.channel?.toLowerCase() == 'd'
                                    ? '#cc6c1d'
                                    : `${journeyState.channel === "28" || journeyState.channel === "35" || journeyState.channel === "39" ? "#db0011" : journeyState.channel === "B" ? "#a20a3a" : journeyState.channel === "C" ? "#fec32b" : "#eb7f25"}` //var(--lumiq-tertiary)
                              }}
                              value="Next"
                              onClick={handlePaymentProceedGiftCity}
                            />
                            {(journeyState.paymentStep === "N" || props.currentPageIndex == 2) &&
                              <div
                                className="provider submit-btn cen re-calculate"
                                tabIndex="0"
                                onKeyPress={(e) => handleEnterRecalculate(e)}
                                onClick={handleReCalculate}
                              >
                                <a>Re-Calculate</a>
                              </div>
                            }
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                ) : (
                <div className="iselect-padding">
                  {/* Desktop tabs */}
                  <div
                    className="payment-option"
                    style={{ background: `${journeyState.channel === "28" || journeyState.channel === "35" || journeyState.channel === "39" ? "#3e505d" : journeyState.channel === "B" ? "#a20a3a" : journeyState.channel === "C" ? "#0ab0ef" : "#eb7f25"}` }}
                  // style={{ background: "var(--lumiq-card-bg)" }}
                  >


                    {/* <h4>Choose Your Preferred Payment Option</h4> */}
                    <div className="payment-form">
                      <>
                        <div
                          style={{
                            textAlign: "center",
                            margin: "2rem 0",
                          }}
                        >
                          <div
                            className="row iAgree"
                            style={{
                              textAlign: "center",
                            }}
                          >
                            <div className="form-group">
                              <div className="inner-addon left-addon align-error" style={{ width: "67%", margin: "auto", alignItems: 'flex-start' }}>
                                <div className="checkbox1">
                                  <input
                                    id="checkboxG7"
                                    className={`css-checkbox form-control`}
                                    type="checkbox"
                                    checked={paymentTermsCond2}
                                    onChange={(e) => handleOnChange("paymentTermsCond2")}
                                  />
                                  {['a', 'c', 'b', 'd'].includes(journeyState?.channel?.toLowerCase()) ?
                                    (<label
                                      htmlFor="checkboxG7"
                                      className="css-label"
                                      style={{ color: "white", filter: "brightness(1)" }}
                                    >
                                      I accept all terms &amp; conditions and hereby declare that premium shall be paid by Proposer.
                                    </label>) :
                                    (<label className="websiteCheckmarkcontainer">
                                      <span style={{
                                        marginLeft: "15px"
                                      }}>I accept all terms &amp; conditions and hereby declare that premium shall be
                                        paid by Proposer.</span>
                                      <input type="checkbox" checked={paymentTermsCond2} onChange={(e) => handleOnChange("paymentTermsCond2")} />
                                      <span className="checkmarkWebsite" />
                                    </label>)}
                                </div>
                                {!paymentTermsCond2 && (<span className="input-error payment-error1" style={{ fontSize: '13px', marginLeft: "5.2rem" }}>
                                  This field is required
                                </span>)}
                              </div>
                            </div>
                          </div>
                          <p>
                            If your age changes during the period your
                            insurance proposal is under consideration with
                            the company, then the premium as per your
                            attained age will apply and you will be required
                            to pay the additional amount for issuing the
                            policy.
                          </p>
                        </div>
                      </>
                      {glomoPay && (
                      <div className="col-lg-6 col-md-12 col-sm-12 col-12">
                        <RadioContainer>
                          <div
                            style={{ borderRadius: "15px" }}
                            className="provider"
                            tabIndex="0"
                          >
                            <label className="width">
                              <input
                                type="radio"
                                name="pay"
                                value="online"
                                hidden
                                onChange={handlePayOption}
                                checked={paymentMethod === "online"}
                              />
                              <div className="card justify-content-center">
                                <div className="checked">
                                  <svg
                                    stroke="currentColor"
                                    fill="currentColor"
                                    stroke-width="0"
                                    viewBox="0 0 512 512"
                                    height="1em"
                                    width="1em"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"></path>
                                  </svg>
                                </div>
                                <div className="amount">
                                  <span>
                                    Online Payment Mode
                                  </span>
                                  <div></div>
                                </div>
                                <div className="desc">
                                  <span>
                                    Continue with your application and pay $
                                    {applyComma(allJourneyData?.productDetails?.installmentPremium ?? '')}
                                  </span>
                                </div>
                              </div>
                            </label>
                          </div>
                        </RadioContainer>
                      </div>
                      )}
                      
                      {swiftPay && (
                      <div className="col-lg-6 col-md-12 col-sm-12 col-12">
                        <RadioContainer>
                          <div style={{ borderRadius: "15px" }} className="provider" tabIndex="0">
                            <label className="width">
                              <input
                                type="radio"
                                name="pay"
                                value="swift"
                                hidden
                                onChange={handlePayOption}
                                checked={paymentMethod === "swift"}
                              />
                              <div className="card justify-content-center">
                                <div className="checked">
                                  <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 512 512" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"></path></svg>
                                </div>
                                <div className="amount">
                                  <span>Swift Payment Mode</span>
                                  <div></div>
                                </div>
                                <div className="desc">
                                  <span>Continue with your application via Swift Payment</span>
                                </div>
                              </div>
                            </label>
                          </div>
                        </RadioContainer>
                      </div>
                      )}

                      <div className="right hidden-desktop-screen">
                        <div
                          className="col-md-12"
                          style={{ paddingTop: "3rem" }}
                        >
                          <div className="but-center text-center">
                            <input
                              type="submit"
                              className="provider previous-btn cen pay-now"
                              tabIndex="0"
                              onMouseOver={(e) => {
                                if (!['a', 'c', 'b', 'd'].includes(journeyState?.channel?.toLowerCase())) {
                                  e.target.style.background = '#404040'
                                  e.target.style.border = '1px solid #404040'
                                }
                              }}
                              onFocus={(e) => {
                                if (!['a', 'c', 'b', 'd'].includes(journeyState?.channel?.toLowerCase())) {
                                  e.target.style.background = journeyState.channel?.toLowerCase() == 'b'
                                    ? `${journeyState.channel === "28" || journeyState.channel === "35" || journeyState.channel === "39" ? "#404040" : journeyState.channel === "B" ? "#a20a3a" : journeyState.channel === "C" ? "#fec32b" : "#eb7f25"}`
                                    : journeyState.channel?.toLowerCase() == 'd'
                                      ? '#cc6c1d'
                                      : `${journeyState.channel === "28" || journeyState.channel === "35" || journeyState.channel === "39" ? "#db0011" : journeyState.channel === "B" ? "#a20a3a" : journeyState.channel === "C" ? "#fec32b" : "#eb7f25"}`
                                  e.target.style.border = '1px solid white'
                                }
                              }}
                              onMouseOut={(e) => {
                                if (!['a', 'c', 'b', 'd'].includes(journeyState?.channel?.toLowerCase())) {
                                  e.target.style.background = journeyState.channel?.toLowerCase() == 'b'
                                    ? `${journeyState.channel === "A" ? "#404040" : journeyState.channel === "B" ? "#a20a3a" : journeyState.channel === "C" ? "#fec32b" : "#eb7f25"}`
                                    : journeyState.channel?.toLowerCase() == 'd'
                                      ? '#cc6c1d'
                                      : `${journeyState.channel === "28" || journeyState.channel === "35" || journeyState.channel === "39" ? "#db0011" : journeyState.channel === "B" ? "#a20a3a" : journeyState.channel === "C" ? "#fec32b" : "#eb7f25"}`
                                  e.target.style.border = '1px solid white'
                                }
                              }}
                              onBlur={(e) => {
                                if (!['a', 'c', 'b', 'd'].includes(journeyState?.channel?.toLowerCase())) {
                                  e.target.style.background = journeyState.channel?.toLowerCase() == 'b'
                                    ? `${journeyState.channel === "28" || journeyState.channel === "35" || journeyState.channel === "39" ? "#404040" : journeyState.channel === "B" ? "#a20a3a" : journeyState.channel === "C" ? "#fec32b" : "#eb7f25"}`
                                    : journeyState.channel?.toLowerCase() == 'd'
                                      ? '#cc6c1d'
                                      : `${journeyState.channel === "28" || journeyState.channel === "35" || journeyState.channel === "39" ? "#db0011" : journeyState.channel === "B" ? "#a20a3a" : journeyState.channel === "C" ? "#fec32b" : "#eb7f25"}`
                                  e.target.style.border = '1px solid white'
                                }
                              }}
                              style={{
                                color: "white",
                                padding: "14px 40px",
                                border: ['a', 'c', 'b', 'd'].includes(journeyState?.channel?.toLowerCase()) ? "none" : "1px solid white",
                                marginLeft: "8px",
                                opacity: !isProceedEnabled ? 0.6 : 1,
                                cursor: !isProceedEnabled ? "not-allowed" : "pointer",
                                background: journeyState.channel?.toLowerCase() == 'b'
                                  ? `${journeyState.channel === "28" || journeyState.channel === "35" || journeyState.channel === "39" ? "#404040" : journeyState.channel === "B" ? "#a20a3a" : journeyState.channel === "C" ? "#fec32b" : "#eb7f25"}` //var(--lumiq-secondary2)
                                  : journeyState.channel?.toLowerCase() == 'd'
                                    ? '#cc6c1d'
                                    : `${journeyState.channel === "28" || journeyState.channel === "35" || journeyState.channel === "39" ? "#db0011" : journeyState.channel === "B" ? "#a20a3a" : journeyState.channel === "C" ? "#fec32b" : "#eb7f25"}` //var(--lumiq-tertiary)
                              }}
                              value={paymentMethod === "swift" ? "Next" : "Proceed"}
                              disabled={!isProceedEnabled}
                              onClick={paymentMethod === "swift" ? handlePaymentProceedGiftCity : checkandPayNow}
                            />
                            {(journeyState.paymentStep === "N" || props.currentPageIndex == 2) &&
                              <div
                                className="provider submit-btn cen re-calculate"
                                tabIndex="0"
                                onKeyPress={(e) => handleEnterRecalculate(e)}
                                onClick={handleReCalculate}
                              >
                                <a>Re-Calculate</a>
                              </div>
                            }
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                )}

                <div className="iselect-padding">
                  <h2 style={{ fontSize: "16px" }}  >Guide: </h2>
                  <ul className="disclosure">
                    <li>
                      You may need to go for a medical examination to complete
                      the application process. Our representative will be in
                      touch with you for any additional information or document
                      or medical test that may be required to assess your
                      insurance proposal.
                    </li>
                    <li>
                      We will need the documents like age proof, address proof,
                      photograph, ID proof and income proof to process your
                      application. You can email, upload or courier the
                      documents after making the premium payment.
                    </li>
                    <li>
                      {" "}
                      The policy will be issued on the basis of the information
                      given by you in this application form.
                    </li>
                    <li>
                      Insurance is a contract of utmost good faith, requiring
                      the Life to be Assured and the Insurer to disclose all
                      material facts. If there is any doubt in response to
                      whether any fact is material, it should be disclosed.
                      Failure to do so may invalidate the contract based on this
                      form.
                    </li>
                    <li>
                      Kindly note that any non-disclosure or misrepresentation
                      or suppression of information with respect to you has a
                      direct impact on the claim decision. It may even lead to
                      repudiation of the claim.
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <!--mobile view button--> */}
      <div className="mobile-view-btn-Q1 pd-mobile-space-structure button1">
        <div className="iselect-mg-bottom">
          <div className="col-md-12">
            <div className="but-center text-center">
              <div className="submit-btn cen" style={{
                opacity : !isProceedEnabled ? 0.6 : 1,
                cursor : !isProceedEnabled ? "not-allowed" : "pointer"
              }} aria-hidden="true" onClick={isProceedEnabled ? (paymentMethod === "swift" ? handlePaymentProceedGiftCity : checkandPayNow) : null}>
                <a>{paymentMethod === "swift" ? "Next" : "Proceed"}</a>
              </div>
              {(journeyState.paymentStep === "N" || props.currentPageIndex == 2) &&
                <div
                  className="previous-btn cen"
                  style={{
                    marginLeft: "5px",
                  }}
                >
                  <a>
                    <button
                      onClick={handleReCalculate}
                      value="button1"
                      style={{
                        height: "24px",
                        width: "initial",
                        backgroundColor: "transparent",
                        padding: "0px 10px",
                        border: "none",
                        color: "#fff",
                      }}
                    >
                      Re-Calculate
                    </button>
                  </a>
                </div>
              }
            </div>
          </div>
        </div>
      </div>
      {/* <!--mobile view button-->  */}
      {showModal && (
        <>
          <div style={{
            position : "fixed",
            top : 0,
            left : 0,
            width : "100%",
            height : "100%",
            opacity : 0.5,
            background : "#000",
            zIndex : 1000
          }}>
          </div>
          <div style={{ position: "fixed", top: "40%", left: "50%", transform: "translate(-50%, -50%)", backgroundColor: "rgba(255, 255, 255)", padding: "20px", border: "3px solid #0088c3", borderRadius: "8px", width: "80%", maxWidth: "600px", zIndex: 9999 }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "15px" }}>
              <h4 style={{ textAlign:"center" , color: "#005575", margin: 0, flex: "1" }}>Benefit Illustration Regeneration</h4>
            </div>
            <p style={{textAlign:"center", fontSize:"15px"}} >Dear Customer, Premium rates for this product is revised as per IRDA guidelines. Request you to regenerate Benfit Illustration</p>
            <button onClick={() => {
              const isProposer = allJourneyData?.lifeAssuredDetails.isLaAndPropSame === "N";
              
              let biSectionIndex
              if (isProposer){  
                biSectionIndex = 6
              }else{  
                biSectionIndex = 3
              }
              let updatePayload = {
                journeyIdFromStrapi : journeyState.journeyIdFromStrapi,
                journeyId : journeyState.journeyId,
                existingPlanCode : allJourneyData?.productDetails?.planOption
              }
              updateProductDetails(updatePayload)
              .then(() => {
                let sendPayload = { 
                  applicationData: journeyState.journeyData,
                  journeyData: {
                    _id: journeyState.journeyId,
                    lastPage: 1,
                    lastSection: biSectionIndex,
                    applicationNo: journeyState.applicationNo,
                    illustrationNumber: journeyState.illustrationNumber,
                    proposalEntryId: journeyState.proposalEntryId,
                    premium: journeyState.premium,
                    lastPageCode: props.pageId,
                    paymentStep: journeyState.paymentStep,
                    lastSectionCode: props.sections[props.currentSectionIndex].sectionId,
                    planOption: journeyState.planOption,
                  },
                }
                saveApplication(sendPayload).then(console.log)
                .catch(console.log)
                .finally(() => {
                  props.setCurrentPageIndex(1)
                  props.setCurrentSectionIndex(biSectionIndex)
                  setShowModal(false)
                })
              })
              .catch(console.log)  
            }} style={{ backgroundColor: "#fec32b", color: "#fff", padding: "8px 16px", border: "none", borderRadius: "4px", cursor: "pointer", display: "block", margin: "0 auto" }}>Ok</button>
          </div>
        </>
  )}
   {(showModalAge&&ageDiff) && ( 
        <>
          <div style={{
            position : "fixed",
            top : 0,
            left : 0,
            width : "100%",
            height : "100%",
            opacity : 0.5,
            background : "#000",
            zIndex : 1000
          }}>
          </div>
          <div style={{ position: "fixed", top: "40%", left: "50%", transform: "translate(-50%, -50%)", backgroundColor: "rgba(255, 255, 255)", padding: "20px", border: "3px solid #0088c3", borderRadius: "8px", width: "80%", maxWidth: "600px", zIndex: 9999 }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "15px" }}>
              <h4 style={{ textAlign:"center" , color: "#005575", margin: 0, flex: "1" }}>Benefit Illustration Regeneration</h4>
            </div>
            <p style={{textAlign:"center", fontSize:"15px"}} >Age is changed from login Date. Please regenerate the BI to proceed further</p>
            <button onClick={() => {
              const isProposer = allJourneyData?.lifeAssuredDetails.isLaAndPropSame === "N";
              
              let biSectionIndex
              if (isProposer){  
                biSectionIndex = 6
              }else{  
                biSectionIndex = 3
              }
    
                let sendPayload = {
                  applicationData: journeyState.journeyData,
                  journeyData: {
                    _id: journeyState.journeyId,
                    lastPage: 1,
                    lastSection: biSectionIndex,
                    applicationNo: journeyState.applicationNo,
                    illustrationNumber: journeyState.illustrationNumber,
                    proposalEntryId: journeyState.proposalEntryId,
                    premium: journeyState.premium,
                    lastPageCode: props.pageId,
                    paymentStep: journeyState.paymentStep,
                    lastSectionCode: props.sections[props.currentSectionIndex].sectionId,
                    planOption: journeyState.planOption,
                  }
                }
              
                saveApplication(sendPayload).then(console.log)
                .catch(console.log)
                .finally(() => {
                  props.setCurrentPageIndex(1)
                  props.setCurrentSectionIndex(biSectionIndex)
                  setShowModalAge(false)
                
              })
              .catch(console.log)  
            }} style={{ backgroundColor: "#fec32b", color: "#fff", padding: "8px 16px", border: "none", borderRadius: "4px", cursor: "pointer", display: "block", margin: "0 auto" }}>Ok</button>
          </div>
        </>
  )}
    </>
  )
}
